<template>
  <div class="gray-back">
    <div class="box member-service-box">
      <van-divider>能力测试 · 人员信息</van-divider>
      <van-divider v-if="qunQrcodeDisplayList.length">群二维码</van-divider>
      <div v-if="qunQrcodeDisplayList.length" class="qrcode-block">
        <div v-for="(url, idx) in qunQrcodeDisplayList" :key="idx" class="qrcode-item">
          <img class="qrcode-img" :src="url" alt="群二维码"/>
        </div>
      </div>
      <van-cell-group v-for="(member, index) in list" :key="index">
        <van-cell title="姓名" :value="member.name"/>
        <van-cell title="性别" :value="member.sex"/>
        <van-cell title="身份证号" :value="member.num"/>
        <van-cell title="联系电话" :value="member.phone"/>
        <van-cell title="微信" :value="member.weixin"/>
        <van-cell title="申报项目" :value="member.project" v-if="row.memberstatus == 6"/>
        <van-cell title="抱腿平衡" :value="member.score_btph"
                  v-if="row.memberstatus == 6 && (member.project== '花球男' || member.project== '花球女')"/>
        <van-cell title="肋木举腿" :value="member.score_lmjt" v-else-if="row.memberstatus == 6"/>
        <van-cell title="60s(击掌)俯卧撑" :value="member.score_fwc" v-if="row.memberstatus == 6"/>
        <van-cell title="技术技巧" :value="member.score_jsjq" v-if="row.memberstatus == 6"/>
        <van-cell title="总分" :value="member.score_total" v-if="row.memberstatus == 6"/>
        <van-cell title="选择项目" :value="member.project" v-else is-link @click="onProjectOpen(index)"/>
      </van-cell-group>

      <van-popup v-model="projectShow" position="bottom">
        <van-picker
            :columns="projectColumns"
            show-toolbar
            @cancel="projectShow = false"
            @confirm="onProjectConfirm"
        />
      </van-popup>
      <div style="height: 50px"/>
      <div class="savebtn" v-if="row.memberstatus != 6">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal"
            round
            native-type="button"
            @click="goPrev"
        >上一步
        </van-button>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal"
            round
            :disabled="saveLoading"
            :loading="saveLoading"
            loading-text="提交中..."
            @click="onSubmit"
        >保存并继续
        </van-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.member-service-box .van-cell__value {
  color: #333;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.qrcode-block {
  padding: 0 0.3rem 0.2rem;
}

.qrcode-item {
  text-align: center;
  margin-bottom: 0.2rem;
}

.qrcode-img {
  width: 70%;
  max-width: 5rem;
  border-radius: 8px;
  display: inline-block;
}
</style>

<script>
import Vue from 'vue';
import {
  Cell,
  CellGroup,
  Toast,
  Button,
  Divider,
  Popup,
  Picker,
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Toast).use(Button).use(Divider).use(Popup).use(Picker);

export default {
  name: 'AbilityApplyStep2',
  computed: {
    qunQrcodeDisplayList() {
      const single = this.row && this.row.qun_qrcode_url;
      if (single) {
        return [single];
      }
      const list = this.row && this.row.qun_qrcode;
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map(item => item && item.url).filter(Boolean);
    },
  },
  data() {
    return {
      baomingId: 0,
      projectShow: false,
      list: [],
      row: {},
      memberIndex: 0,
      saveLoading: false,
      projectColumns: ['花球/爵士男', '花球/爵士女', '技巧男', '技巧女', '街舞男', '街舞女'],
    };
  },
  mounted() {
    document.title = '能力测试 · 人员信息';
    const qid = this.$route.query.id;
    this.baomingId = qid ? parseInt(qid, 10) : 0;
    if (isNaN(this.baomingId) || this.baomingId <= 0) {
      Toast.fail('缺少报名编号');
      return;
    }
    this.getList();
  },
  methods: {
    goPrev() {
      rbLink({ name: 'AbilityApplyStep1', query: { id: this.baomingId } });
    },
    getList() {
      const that = this;
      that.$api.get('/api/ability/abilityApplyMemberList', {
        id: that.baomingId,
      }, (res) => {
        that.list = res.data.list;
        that.row = res.data.row;
      }, (res) => {
        Toast.fail(res.msg || '加载失败');
      });
    },

    onProjectOpen(index) {
      this.projectShow = true;
      this.memberIndex = index;
    },

    onProjectConfirm(value) {
      this.list[this.memberIndex].project = value;
      this.projectShow = false;
    },

    onSubmit() {
      const that = this;
      let invalid = false;
      that.list.forEach((field) => {
        if (!field.project) {
          Toast(field.name + '请选择项目');
          invalid = true;
        }
      });
      if (invalid) {
        return;
      }
      that.saveLoading = true;
      that.$api.post('/api/ability/memberServiceApply', {
        id: that.baomingId,
        list: JSON.stringify(that.list),
      }, () => {
        that.saveLoading = false;
        Toast.success('保存成功');
        rbLink({ name: 'AbilityApplyStep3', query: { id: that.baomingId } }, 'replace');
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// AbilityApplyStep2.vue?b830724e